<template>
  <div class="cols">
    <h2 class="px-20">{{ $t('settings.on-board.title.users') }}</h2>
    <Users
        :search-token="searchToken"
        :selected-user-id="selectedUserId"
        @on-select-user="onSelectUser"
    />
    <h2 class="px-20">{{ $t('settings.on-board.title.groups') }}</h2>
    <Groups
        :search-token="searchToken"
        :selected-user-id="selectedUserId"
        :selected-group-id="selectedGroupId"
        @on-select-group="onSelectGroup"
    />
    <h2 class="px-20">{{ $t('settings.on-board.title.car-fleet') }}</h2>
    <Devices
        :search-token="searchToken"
        :selected-group-id="selectedGroupId"
        :selected-device-id="selectedDeviceId"
        @on-select-device="onSelectDevice"
    />
    <h2 class="px-20">{{ $t('settings.on-board.title.recipients') }}</h2>
    <Recipients
        :search-token="searchToken"
        :selected-vehicle-recipient-id="selectedVehicleRecipientId"
        @on-select-vehicle-recipient="onSelectVehicleRecipient"
    />
    <h2 class="px-20">{{ $t('settings.on-board.title.events') }}</h2>
    <Notifications :search-token="searchToken"/>
  </div>
</template>

<script>
import Users from '@/components/pages/on-boarding/Users';
import Groups from '@/components/pages/on-boarding/Groups';
import Devices from '@/components/pages/on-boarding/Devices';
import Recipients from '@/components/pages/on-boarding/Recipients';
import {actions} from '@/assets/js/vue/vuex/actions';
import notification from '@/assets/js/notification';
import Notifications from "@/components/pages/on-boarding/Notifications.vue";

export default {
  name: 'OnBoard',
  components: {Notifications, Recipients, Users, Groups, Devices},
  props: {
    searchToken: String,
  },
  data() {
    return {
      selectedUserId: null,
      selectedGroupId: null,
      selectedDeviceId: null,
      selectedVehicleRecipientId: null,
      selectedNotificationsUserId: null,
    };
  },
  mounted() {
    this.$store.dispatch(actions.GET_USERS).catch(e => notification.error(this.$t(e.message)));
    this.$store.dispatch(actions.GET_COMPANIES).catch(e => notification.error(this.$t(e.message)));
  },
  methods: {
    onSelectUser(id) {
      this.selectedUserId = id;

      if (id !== null) {
        this.$store.dispatch(actions.GET_GROUPS, {userId: id}).
            then(groups => this.selectedGroupId = groups[0] !== undefined ? (groups[0].id || null) : null).
            catch(e => notification.error(this.$t(e.message)));
      }
    },
    onSelectGroup(id) {
      this.selectedGroupId = id;
    },
    onSelectDevice(id) {
      this.selectedDeviceId = id;
    },
    onSelectVehicleRecipient(id) {
      this.selectedVehicleRecipientId = id;
    },
  },
};
</script>
